import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export interface StartupPayload
{
	stripePublicKey: string;
	radarPublicKey: string;
}

@Injectable()
export class GeneralRepository
{
	private requestMapping: string = "general";
	private http: HttpClient;

	public constructor(http: HttpClient)
	{
		this.http = http;
	}

	public getStartupInfo(): Observable<StartupPayload>
	{
		return this.http.get<StartupPayload>(`${this.requestMapping}/startup`);
	}
}
